// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e5728b72","113":"6ecf457d","270":"75d77ab8","555":"92a1d1c1","608":"52239fe8","737":"3ca0bd7a","835":"26b8ea64"}[chunkId] + ".chunk.js";
};